export default __webpack_public_path__ + "static/media/venture_capital_step.cf95a140.svg";